import { createFileRoute } from '@tanstack/react-router'
import { TagsSettingsPage } from '@/features/settings/components/tags-settings-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/settings/tags',
)({
  component: TagsSettingsPage,
  beforeLoad: async () => {
    return {
      title: 'Tags',
      headerTitleKey: 'header.tags.title',
      headerDescriptionKey: 'header.tags.description',
    }
  },
})
